import { SITE_URL } from '@/config/seo';
import { getJobDetailPath } from '@/services/jobs';
import type { JobSummary } from '@/services/jobs/model';

export const JOB_SEARCH_STRUCTURED_DATA_SCRIPT_ID =
  'job-search-structured-data';

export type JobSearchStructuredDataConfig = {
  breadcrumbName?: string;
  canonicalPath: string;
  description: string;
  jobs: JobSummary[];
  name: string;
  total: number;
};

function getAbsoluteUrl(path: string) {
  return new URL(path, SITE_URL).toString();
}

export function getJobSearchStructuredData({
  breadcrumbName,
  canonicalPath,
  description,
  jobs,
  name,
  total,
}: JobSearchStructuredDataConfig) {
  const canonicalUrl = getAbsoluteUrl(canonicalPath);
  const itemListId = `${canonicalUrl}#jobs`;
  const breadcrumbItems = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Trang chủ',
      item: SITE_URL.origin,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Việc làm',
      item: getAbsoluteUrl('/viec-lam'),
    },
    ...(breadcrumbName && canonicalPath !== '/viec-lam'
      ? [
          {
            '@type': 'ListItem',
            position: 3,
            name: breadcrumbName,
            item: canonicalUrl,
          },
        ]
      : []),
  ];

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      '@id': `${canonicalUrl}#collection`,
      url: canonicalUrl,
      name,
      description,
      numberOfItems: total,
      inLanguage: 'vi-VN',
      mainEntity: { '@id': itemListId },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      '@id': `${canonicalUrl}#breadcrumb`,
      itemListElement: breadcrumbItems,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      '@id': itemListId,
      name,
      numberOfItems: total,
      itemListOrder: 'https://schema.org/ItemListOrderAscending',
      itemListElement: jobs.map((job, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: getAbsoluteUrl(getJobDetailPath(job)),
      })),
    },
  ];
}

export function serializeJobSearchStructuredData(
  structuredData: ReturnType<typeof getJobSearchStructuredData>
) {
  return JSON.stringify(structuredData).replaceAll('<', '\\u003c');
}
